import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["key", "title", "children", "_isLeaf"],
    _excluded2 = ["key", "title", "children"],
    _excluded3 = ["key", "title", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import warning from 'warning';
import { parseInt } from 'lodash-es';
var scrollbarSize; // Measure scrollbar width for padding body during modal show/hide

var scrollbarMeasure = {
  position: 'absolute',
  top: '-9999px',
  width: '50px',
  height: '50px',
  overflow: 'scroll'
}; //注意需要处理各系统及各浏览器的兼容性

export function measureScrollbar(selectors) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'vertical';

  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0;
  }

  if (scrollbarSize) {
    //计算一次即可
    return scrollbarSize;
  }

  var brow = myBrowser(); //window系统下firefox的offsetWidth同clientWidth一致，所以通过父子容器间带滚动条的墨盒尺寸计算出滚动条宽度

  if (['IE', 'FF'].includes(brow.browserType) && brow.osType == 'Win') {
    var scrollDivParent = document.createElement('div');
    scrollDivParent.setAttribute("id", 'measureScrollbar_temp');
    scrollDivParent.style.position = 'absolute';
    scrollDivParent.style.top = '-9999px';
    scrollDivParent.style.overflow = 'scroll'; // scrollDivParent.style.background = 'red';

    scrollDivParent.style.width = '50px';
    scrollDivParent.style.height = '100px';
    var scrollDivChild = document.createElement('div'); // scrollDivChild.style.background = 'green';

    scrollDivChild.style.height = '200px';
    scrollDivChild.style.flex = "1";
    scrollDivParent.appendChild(scrollDivChild);
    var a = document.getElementById('measureScrollbar_temp');

    if (a) {
      document.body.replaceChild(scrollDivParent, a);
    } else {
      document.body.appendChild(scrollDivParent);
    }

    var _scrollbarSize = scrollDivParent.getBoundingClientRect().width - scrollDivChild.getBoundingClientRect().width;

    document.body.removeChild(scrollDivParent);
    scrollDivParent = null;
    scrollDivChild = null;
    return _scrollbarSize;
  } else if ('FF' == brow.browserType && brow.osType == 'Mac') {
    return 8; //Mac系统的Firefox无法正常计算出滚动条宽度，所以推荐返回默认宽度
  } else {
    var tableDom = document.querySelector(selectors);
    var currentDom = tableDom ? tableDom : document.body;
    var scrollDiv = document.createElement('div');
    Object.keys(scrollbarMeasure).forEach(function (scrollProp) {
      scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
    });
    currentDom.appendChild(scrollDiv);
    scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    currentDom.removeChild(scrollDiv);
    currentDom = null;
    return scrollbarSize;
  }
}
export function myBrowser() {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串

  var browserType = '',
      osType = '';

  if (userAgent.indexOf("Opera") > -1) {
    //判断是否Opera浏览器
    browserType = "Opera";
  } else if (userAgent.indexOf("Firefox") > -1) {
    //判断是否Firefox浏览器
    browserType = "FF";
  } else if (userAgent.indexOf("Chrome") > -1) {
    browserType = "Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    //判断是否Safari浏览器
    browserType = "Safari";
  } else if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 || userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1 //ie版本11
  ) {
    //判断是否IE浏览器
    browserType = "IE";
  }

  if (userAgent.indexOf("Win") > -1) {
    osType = 'Win';
  } else if (userAgent.indexOf("Mac") > -1) {
    osType = 'Mac';
  }

  return {
    browserType: browserType,
    osType: osType
  };
}
export function debounce(func, wait, immediate) {
  var timeout;
  return function debounceFunc() {
    var context = this;
    var args = arguments; // https://fb.me/react-event-pooling

    if (args[0] && args[0].persist) {
      args[0].persist();
    }

    var later = function later() {
      timeout = null;

      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      later();
    }, wait); // 兼容火狐浏览器的写法

    if (callNow) {
      func.apply(context, args);
    }
  };
}
var warned = {};
export function warningOnce(condition, format, args) {
  if (!warned[format]) {
    warning(condition, format, args);
    warned[format] = true;
  }
}
export function getOffset(Node, offset) {
  if (!offset) {
    offset = {};
    offset.top = 0;
    offset.left = 0;
  }

  if (Node == document.body) {
    return offset;
  }

  offset.top += Node.offsetTop;
  offset.left += Node.offsetLeft;
  if (Node.offsetParent) return getOffset(Node.offsetParent, offset);else return offset;
}
;
export var tryParseInt = function tryParseInt(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var resultValue = parseInt(value);

  if (isNaN(resultValue)) {
    return defaultValue;
  }

  return resultValue;
};
export function addClass(elm, className) {
  if (!className) return;
  var els = Array.isArray(elm) ? elm : [elm];
  els.forEach(function (el) {
    if (el.classList) {
      el.classList.add(className.split(' '));
    } else {
      el.className += " ".concat(className);
    }
  });
}
export function removeClass(elm, className) {
  if (!className) return;
  var els = Array.isArray(elm) ? elm : [elm];
  els.forEach(function (el) {
    if (el.classList) {
      el.classList.remove(className.split(' '));
    } else {
      el.className = el.className.replace(new RegExp("(^|\\b)".concat(className.split(' ').join('|'), "(\\b|$)"), 'gi'), ' ');
    }
  });
}
/**
 * 简单数组数据对象拷贝
 * @param {*} obj 要拷贝的对象
 */

export function ObjectAssign(obj) {
  var b = obj instanceof Array;
  var tagObj = b ? [] : {};

  if (b) {
    //数组
    obj.forEach(function (da) {
      var _da = {};
      Object.assign(_da, da);
      tagObj.push(_da);
    });
  } else {
    Object.assign(tagObj, obj);
  }

  return tagObj;
}
/**
 * 获取某个父元素
 * */

export function closest(ele, selector) {
  var matches = ele.matches || ele.webkitMatchesSelector || ele.mozMatchesSelector || ele.msMatchesSelector;

  if (matches) {
    while (ele) {
      if (matches.call(ele, selector)) {
        return ele;
      } else {
        ele = ele.parentElement;
      }
    }
  }

  return null;
}
export function getMaxColChildrenLength(columns) {
  var arr = [];
  arr = columns.map(function (item, index) {
    var chilrenLen = 0;

    if (item.children) {
      chilrenLen = getColChildrenLength(item.children, chilrenLen + 1);
    }

    return chilrenLen;
  });
  var max = Math.max.apply(null, arr);
  return max;
}
export function getColChildrenLength(columns, chilrenLen) {
  columns.forEach(function (item, index) {
    if (item.children) {
      chilrenLen = getColChildrenLength(item.children, chilrenLen + 1);
    }
  });
  return chilrenLen;
}

function addHandler(element, type, handler) {
  if (!element) return;
  var event = null;

  if (element.addEventListener) {
    //检测是否为DOM2级方法
    event = element.addEventListener(type, handler, false);
  } else if (element.attachEvent) {
    //检测是否为IE级方法
    event = element.attachEvent("on" + type, handler);
  } else {
    //检测是否为DOM0级方法
    event = element["on" + type] = handler;
  }

  return event;
}

function removeHandler(element, type, handler) {
  if (element && element.removeEventListener) {
    //element&& ie11报错兼容
    element.removeEventListener(type, handler, false);
  } else if (element && element.detachEvent) {
    element.detachEvent("on" + type, handler);
  } else if (element) {
    element["on" + type] = null;
  }
} //获取事件对象的兼容性写法


function getEvent(event) {
  return event ? event : window.event;
} //获取事件对象目标的兼容性写法


function getTarget(event) {
  return event.target || event.srcElement;
}

function preventDefault(event) {
  if (event.preventDefault) {
    event.preventDefault();
  } else {
    event.returnValue = false;
  }
}

function stopPropagation(event) {
  if (event.stopPropagation) {
    event.stopPropagation();
  } else {
    event.cancelBubble = true;
  }
} //用事件冒泡方式，如果想兼容事件捕获只需要添加个bool参数


export var EventUtil = {
  addHandler: addHandler,
  removeHandler: removeHandler
};
/*
 * 处理精度
 */

export function DicimalFormater(value, precision) {
  var value = value + '',
      precision = precision ? precision : 0;

  for (var i = 0; i < value.length; i++) {
    if ("-0123456789.".indexOf(value.charAt(i)) == -1) return "";
  }

  return checkDicimalInvalid(value, precision);
}
;
export function checkDicimalInvalid(value, precision) {
  if (value == null || isNaN(value)) return ""; // 浮点数总位数不能超过10位

  var digit = parseFloat(value);
  var result = (digit * Math.pow(10, precision) / Math.pow(10, precision)).toFixed(precision);
  if (result == "NaN") return "";
  return result;
}
;
/**
 * 将数值转化为货币类型
 * @param {*} number 数值
 * @param {*} places 精度
 * @param {*} thousand 是否展示千分位
 */

export function formatMoney(number, places, thousand) {
  number = number || 0;
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  var thousandSymbol = thousand ? "," : '';
  var negative = number < 0 ? "-" : "";
  var i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "";
  var j = i.length > 3 ? j % 3 : 0;
  return negative + (j ? i.substr(0, j) + thousandSymbol : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandSymbol) + (places ? '.' + Math.abs(number - i).toFixed(places).slice(2) : "");
}
export var Event = {
  addHandler: addHandler,
  removeHandler: removeHandler,
  getEvent: getEvent,
  getTarget: getTarget,
  preventDefault: preventDefault,
  stopPropagation: stopPropagation
};
/**
 * 将一维数组转换为树结构
 * @param {*} treeData  扁平结构的 List 数组
 * @param {*} attr 属性配置设置
 * @param {*} flatTreeKeysMap 存储所有 key-value 的映射，方便获取各节点信息
 */

export function convertListToTree(treeData, attr, flatTreeKeysMap) {
  var tree = []; //存储所有一级节点

  var resData = treeData,
      //resData 存储截取的节点 + 父节点（除一级节点外）
  resKeysMap = {},
      //resData 的Map映射
  treeKeysMap = {}; //tree 的Map映射

  resData.map(function (element) {
    var key = attr.id;
    resKeysMap[element[key]] = element;
  }); // 查找父节点，为了补充不完整的数据结构

  var findParentNode = function findParentNode(node) {
    var parentKey = node[attr.parendId];

    if (parentKey !== attr.rootId) {
      //如果不是根节点，则继续递归
      var item = flatTreeKeysMap[parentKey]; // 用 resKeysMap 判断，避免重复计算某节点的父节点

      if (resKeysMap.hasOwnProperty(item[attr.id])) return;
      resData.unshift(item);
      resKeysMap[item[attr.id]] = item;
      findParentNode(item);
    } else {
      // 用 treeKeysMap 判断，避免重复累加
      if (!treeKeysMap.hasOwnProperty(node[attr.id])) {
        var key = node.key,
            title = node.title,
            children = node.children,
            _isLeaf = node._isLeaf,
            otherProps = _objectWithoutProperties(node, _excluded);

        var obj = {
          key: key,
          title: title,
          _isLeaf: _isLeaf,
          children: []
        };
        tree.push(Object.assign(obj, _objectSpread({}, otherProps)));
        treeKeysMap[key] = node;
      }
    }
  }; // 遍历 resData ，找到所有的一级节点


  for (var i = 0; i < resData.length; i++) {
    var item = resData[i];

    if (item[attr.parendId] === attr.rootId && !treeKeysMap.hasOwnProperty(item[attr.id])) {
      //如果是根节点，就存放进 tree 对象中
      var key = item.key,
          title = item.title,
          children = item.children,
          otherProps = _objectWithoutProperties(item, _excluded2);

      var obj = {
        key: item[attr.id],
        _isLeaf: item[attr._isLeaf],
        children: []
      };
      tree.push(Object.assign(obj, _objectSpread({}, otherProps)));
      treeKeysMap[key] = item;
      resData.splice(i, 1);
      i--;
    } else {
      //递归查找根节点信息
      findParentNode(item);
    }
  } // console.log('resData',resKeysMap);


  var run = function run(treeArrs) {
    if (resData.length > 0) {
      for (var _i = 0; _i < treeArrs.length; _i++) {
        for (var j = 0; j < resData.length; j++) {
          var _item = resData[j];

          if (treeArrs[_i].key === _item[attr.parendId]) {
            var _key = _item.key,
                _title = _item.title,
                _children = _item.children,
                _otherProps = _objectWithoutProperties(_item, _excluded3);

            var _obj = {
              key: _item[attr.id],
              _isLeaf: _item[attr._isLeaf],
              children: []
            };

            treeArrs[_i].children.push(Object.assign(_obj, _objectSpread({}, _otherProps)));

            resData.splice(j, 1);
            j--;
          }
        }

        run(treeArrs[_i].children);
      }
    }
  };

  run(tree);
  return tree;
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/lib/utils.js